import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { REQUEST_STATUSES } from 'common/constants';
import { addQueryCases } from 'common/helpers';


const name = 'student';

const ENDPOINTS = {
  student: (slug, id) => `/api/v1/career_center/directions/${slug}/${id}/`,
  add: (slug, id) => `/api/v1/career_center/directions/${slug}/${id}/create_request_alumni/`
};

export const getStudent = createAsyncThunk(
  `${name}/getStudent`,
  async ({ slug, id }, { extra: api }) => {
    const response = await api.get(ENDPOINTS.student(slug, id));
    return response.data;
  }
);

export const addRequest = createAsyncThunk(
  `${name}/addRequest`,
  // Ошибку отдаём как rejected с ответом сервера: форма показывает
  // ошибки по полям под нужными полями, остальное — общей плашкой.
  async ({ slug, id, alumni, name, number, nameCompany }, { extra: api, rejectWithValue }) => {
    try {
      const response = await api.post(ENDPOINTS.add(slug, id), {
        alumni,
        name,
        number,
        company_name: nameCompany
      });
      return { status: response.status, data: response.data };
    } catch (e) {
      return rejectWithValue(e.response?.data ?? null);
    }
  }
);

const initialState = {
  [ name + 'Status' ]: REQUEST_STATUSES.NOT_REQUESTED,
  [ name + 'Data' ]: {},
  [ name + 'Error' ]: null
};

const studentSlice = createSlice({
  name,
  initialState,
  reducers: {
    resetStudent: (state) => {
      state[ name + 'Data' ] = {};
    }
  },
  extraReducers(builder) {
    addQueryCases(builder, getStudent, {
      status: [ name + 'Status' ],
      data: [ name + 'Data' ],
      error: [ name + 'Error' ],
      options: { concat: false }
    });
  }
});

export default studentSlice;

export const studentSelect = (state) => state?.[ name ];
export const { resetStudent } = studentSlice.actions;
